import { render, staticRenderFns } from "./DlgEventSendGuestEmail.vue?vue&type=template&id=08b6805a"
import script from "./DlgEventSendGuestEmail.vue?vue&type=script&lang=ts"
export * from "./DlgEventSendGuestEmail.vue?vue&type=script&lang=ts"
import style0 from "./DlgEventSendGuestEmail.vue?vue&type=style&index=0&id=08b6805a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports